/* global jQuery, confirm */
/* eslint eqeqeq: "warn", curly: "error", new-cap: "off", no-alert: "off", wrap-iife: "off", no-new: "warn" */
require('./bootstrap');
require('../../../node_modules/jquery-ui-bundle');
require('./components/stickytabs');
jQuery(document).ready(function ($) {
	$.ajaxSetup({
		headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
	});

	// Highlight validation errors on most pages

	if (typeof (error_keys) !== 'undefined') {
		for (i = 0; i < error_keys.length; i++) {
			if (error_keys[i].includes('.')){
				var name = error_keys[i].replace(/\.(.+)$/gi, '[$1]');
				$('[name="' + name + '"]').css('background', '#ffff99');
			}else {
				$('[name="' + error_keys[i] + '"]').css('background', '#ffff99');
			}
		}
	}

	$('.btn-danger').click(function (e) {
		var res = confirm('Are you sure you want to take this action?');
		if (!res){
			e.stopImmediatePropagation();
		}
		return res;
	});

	$('.search-submit').on('click keydown', function (e) {
		if (e.type === 'click' || (e.type === 'keydown' && e.keyCode === 13)) {
			$(this).parent().submit();
		}
	});

	$(window).on('scroll', function (e) {
		if ($(window).scrollTop() > 53) {
			$('nav.navbar').addClass('navbar-scrolled');
		} else {
			$('nav.navbar').removeClass('navbar-scrolled');
		}
	});
	$('#checkall').click(function () {
		var checkedStatus = this.checked;
		$('.checkdelete').each(function () {
			$(this).prop('checked', checkedStatus);
		});
	});
	$('.togglechecks').change(function () {
		$(this).parent().submit();
	});
	$('#rowsperpage').change(function () {
		var urlvars = getUrlVars();
		var url = document.createElement('a');
		url.href = window.location.href;
		url.href = url.protocol + '//' + url.hostname + url.pathname + '/?';
		if (urlvars.length > 1) {
			for (var i = 0; i < urlvars.length; i++) {
				if (urlvars[i] !== 'limit' && typeof urlvars[urlvars[i]] !== 'undefined') {
					url.href += urlvars[i] + '=' + urlvars[urlvars[i]] + '&';
				} else if (urlvars[i] === 'limit') {
					url.href += 'limit=' + this.value + '&';
				}
			}
		} else {
			url.href += 'limit=' + this.value;
		}
		window.location.href = encodeURI(url.href);
	});
	// Fade out boostrap alerts
	$('div.alert').not('.alert-important').delay(4000).fadeOut(500);

	$('.spread-edit').on('click', 'td', function () {
		$(this).children('.form-control').show();
		$(this).children('span').hide();
	});

	$('.spread-delete').on('click', function () {
		var self = this;
		var id = this.dataset.spreadingId;
		jQuery.ajax({
			url: '/site/spreading/' + id + '/destroy',
			method: 'post',
			data: {
				name: jQuery('#name').val(),
				type: jQuery('#type').val(),
				price: jQuery('#price').val()
			},
			success: function (result) {
				$('#spreadmessage').text(result.message);
				$('#spreadmessage').css('display', 'block').delay(10000).hide(500);
				$(self).parents('tr').hide(500).remove();
			}
		});
	});

	// Read a page's GET URL variables and return them as an associative array.
	function getUrlVars () {
		var vars = [];
		var hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
});
